<template>
  <div id="wrap">
    <app-header />
    <header-step step="4" alt="ステップ４：完了" />

    <main>
      <h2><span>お申込みを完了しました</span></h2>
      <div class="complete">
        <p class="mb1">
          「ツイタもん」にお申込みいただき、 誠にありがとうございます。<br />

          ICタグの準備ができましたら、
          学校を通じてICタグを配布させていただきます。<br />
          配布まで今しばらくお待ちください。<br />
        </p>
        <p>今後とも「ツイタもん」をよろしくお願い申し上げます。<br /></p>
      </div>
      <div class="btn">
        <button type="button" class="back" @click="onClickBack">
          ツイタもん トップページへ戻る
        </button>
      </div>
    </main>

    <app-footer />

    <scroll-to-top />
  </div>
</template>

<script>
import CmnSubMixin from "@mixins/cmnsub-mixin";
import AppHeader from "@components/AppHeader";
import HeaderStep from "@components/HeaderStep";
import AppFooter from "@components/AppFooter";
import ScrollToTop from "@components/ScrollToTop";
import AppConst from "@utils/app-const";

export default {
  name: "Complete",
  mixins: [CmnSubMixin],
  components: {
    AppHeader,
    HeaderStep,
    AppFooter,
    ScrollToTop,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {
    window.addEventListener("pageshow", function (evt) {
      if (evt.persisted) {
        // ヒストリバックを使えなくする
        window.history.pushState(null, null, window.location.href);
      }
    });
    // ヒストリバックを使えなくする
    window.history.pushState(null, null, window.location.href);
    window.addEventListener("popstate", function () {
      window.history.go(1);
    });
  },
  methods: {
    /**
     * 戻るボタン
     */
    onClickBack: function () {
      window.location.href = AppConst.HP_URL;
    },
  },
  watch: {},
};
</script>
